import styles from "./index.module.css";
import React from "react";
import { Grid, Box } from "@mui/material";
import { getOnLine, getWalletOnLine } from "../../../api/saaservices/onLine";
import { useState, useEffect } from "react";
import PrintIcon from "@mui/icons-material/Print";
import DescriptionIcon from "@mui/icons-material/Description";
import { useSelector, useDispatch } from "react-redux";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useTranslation } from "react-i18next";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { format, parse } from "date-fns";
import usePagination from "./Pagination";
import { exportExcel, exportPDF } from "../../../helpers/exportExcel";
import Swal from "sweetalert2";
import { Currency, currencyFormat } from "../../../helpers/currencyConvert";
import { Button, Tabs, Tab, Pagination } from "@mui/material";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import ModalProviders from "./ModalProviders/index";
import printTable from "../../../helpers/imprimir";
import my_agencies, {
  setSelectedAgencieToConsult,
} from "../../../store/slices/my_agencies";
import { useLocation, useNavigate } from "react-router-dom";
import AgencySelectModal from "../../Shared/AgencySelectModal/AgencySelectModal";
import CircularProgress from "@mui/material/CircularProgress";
import { formatArg } from "../../../config/strings";
import { configDate } from "../../../helpers/convertDate";
import {
  AgencyPage,
  getPresentAgencyInPath,
  logOutPath,
  hasAgencyInPath,
  getAgencyNumberDisplay,
} from "../../../helpers/path";
import { unique } from "../../../helpers/arrays";
import { updateLocation } from "../../../store/slices/localSlice";
import { CalendarioHoy, CalendarioSemanaPasada } from "../../../helpers/today";
import { getSaaId } from "../../../utils/session.utils";
import walletMock from "./mock";

export const OnLine = () => {
  const [isReady, setIsReady] = useState(true);
  const [openFilter, setOpenFilter] = useState(false);
  //const [dateFrom, setDateFrom] = useState(
  //  diaAyer() > minDateRange ? diaAyer() : minDateRange
  //);
  //const [dateTo, setDateTo] = useState(diaHoy());
  const firstDayMonth = new Date().setDate(1);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(CalendarioHoy());
  const { imputations, organization_Configuration } = useSelector(
    (state) => state.gamma,
  );
  const { activeOrganization } = useSelector((state) => state.gamma);
  const [movimientos, setMovimientos] = useState([]);
  const agencies = useSelector((state) => state.myAgencies.user_agencies);
  const { textColor } = useSelector((state) => state.local);
  const [search, setSearch] = useState(false);
  const [searching, setSearching] = useState(false);
  const [print, setPrint] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const agencieSelected = useSelector(
    (state) => state.myAgencies?.selected_agencie_to_consult,
  );
  const [filterParams, setFilterParams] = useState({
    dateFrom: diaAyer(),
    dateTo: diaHoy(),
    game: "",
    concept: "",
  });
  const { formatLocalDate, formatLocalDateTime } = configDate();
  const location = useLocation();
  const actualPage = useSelector(
    (state) => state.pagination.currentAccountActualPage,
  );
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState();
  const [tabValue, setTabValue] = useState("daily");

  // Wallet (Deposits & Withdrawals) state - mocked for now
  const [walletMovements, setWalletMovements] = useState([]);
  const [walletPage, setWalletPage] = useState(1);
  const [walletPageSize] = useState(10);

  const page = usePagination(
    actualPage,
    imputations?.totalPages,
    agencieSelected?.id,
  );
  const handlePagination = (e, p) => {
    page.jump(p);
  };

  const { formatCurrency } = currencyFormat();

  const defaultMovimientos = {
    headers: [],
    movements: [],
  };

  
  function diaAyer() {
    let d = new Date();
    d.setDate(d.getDate() - 1);
    return format(d, formatArg);
  }

  function diaHoy() {
    return format(new Date(), formatArg);
  }

  async function loadMovimientos(agencie, dateTo, dateFrom) {
    const saaId = getSaaId();
    return await getOnLine(
      saaId,
      dateFrom,
      dateTo,
      agencie.number,
      agencie.subNumber === null ? -1 : agencie.subNumber,
    );
  }

  const toJsDate = (value) => {
    if (!value) return null;
    try {
      // mock.fecha viene como "yyyy-MM-dd" en el mock actual
      const parsed = parse(value, "yyyy-MM-dd", new Date());
      return parsed;
    } catch (e) {
      return null;
    }
  };

  const formatDateLtn = (date) => {
    return date.replaceAll("/", "-");
  };

  const loadWalletMovements = async (agencie) => {
    // Usa la agencia seleccionada y los filtros de fecha (desde/hasta)
    setLoading(true);
    if (!agencie || !agencie.number) {
      setWalletMovements([]);
      setLoading(false);
      return;
    }

    const params = {
      agencia: agencie.number,
      fechaDesde: formatDateLtn(filterParams.dateFrom || diaAyer()),
      fechaHasta: formatDateLtn(filterParams.dateTo || diaHoy()),
      codigoOrganizacion: getSaaId(),
      subagencia:
        agencie.subNumber === null ? -1 : agencie.subNumber,
    };

    try {
      const data = await getWalletOnLine(params);
      setWalletMovements(data);
    } catch (error) {
      console.error(error);
      // En caso de error, dejamos la data mock para no romper la vista
      const all = walletMock?.movimientos || [];
      setWalletMovements(all);
    } finally {
      setLoading(false);
    }
  };

  async function attemptLoadMovimientos() {
    if (agencieSelected) {
      setLoading(true);
      await loadMovimientos(
        agencieSelected,
        filterParams.dateTo,
        filterParams.dateFrom,
      )
        .then((mov) => {
          setMovimientos(mov);
          setLoading(false);
        })
        .catch((error) => console.log(error));
    }
  }

  const excelItem = () => {
    let excelData = [];
    if (tabValue === "daily") {
      if (!movimientos?.length) {
        const itemData = {};
        itemData[t("subagency")] = "";
        itemData[t("client")] = "";
        itemData[t("date")] = "";
        itemData[t("imputation")] = "";
        itemData[t("descriptionCode")] = "";
        itemData[t("couponQuantity")] = "";
        itemData[t("total")] = "";
        excelData.push(itemData);
      } else {
        const traverse = movimientos?.forEach((item) => {
          const itemData = {};
          itemData[t("subagency")] = item.subagencia;
          itemData[t("client")] = item.cliente;
          itemData[t("date")] = item.fecha;
          itemData[t("imputation")] = item.descripcionJuego;
          itemData[t("descriptionCode")] = item.movimiento;
          itemData[t("couponQuantity")] = item.cantidadCupones;
          itemData[t("total")] = formatCurrency(item.totalImporte);
          excelData.push(itemData);
        });
      }
    } else if (tabValue === "wallet") {
      if (!walletMovements?.length) {
        const itemData = {};
        itemData[t("salePoint")] = "";
        itemData[t("movements")] = "";
        itemData[`${t("totalMovements")} ($)`] = "";
        excelData.push(itemData);
      } else {
        walletMovements.forEach((item) => {
          const itemData = {};
          itemData[t("salePoint")] = item.puntoVenta;
          itemData[t("movements")] = item.movimiento;
          itemData[`${t("totalMovements")} ($)`] = formatCurrency(item.importe);
          excelData.push(itemData);
        });
      }
    }
    return excelData;
  };

  const excelDownload = () => {
    Swal.fire({
      title: t("excelConfirm"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      cancelButtonText: t("cancel"),
      confirmButtonText: t("accept"),
    }).then((result) => {
      if (result.isConfirmed) {
        let today = new Date();

        // Si el mensaje de "no hay resultados" está activo, 
        // entonces no hay datos para mostrar, por lo que se muestra el mensaje en el Excel. 
        // Caso contrario, se muestra la data normalmente.
        const isEmpty = 
        tabValue === "daily"
          ? !movimientos?.length
          : !walletMovements?.length;

        exportExcel(
          excelItem(),
          tabValue === "daily"
            ? `Detalle_Movimientos_Diarios_${today.toISOString()}`
            : `Detalle_Movimientos_Billetera_${today.toISOString()}`,
          isEmpty,
        );
      }
    });
  };

  function showHide() {
    setShowModal(!showModal);
  }

  const handleChangeTab = (event, value) => {
    setTabValue(value);
    if (value === "wallet") {
      setWalletPage(1);
      loadWalletMovements(agencieSelected);
    }
  };

  const handleConsulting = (agencie) => {
    if (typeof agencie === "object" && Object.keys(agencie).length !== 0) {
      dispatch(setSelectedAgencieToConsult(agencie));
    }
    setLoading(true);
    tabValue === "wallet"
      ? loadWalletMovements(agencie).then(() => setLoading(false))
      : loadMovimientos(
          agencie,
          filterParams.dateTo,
          filterParams.dateFrom,
        ).then((mov) => {
          setMovimientos(mov);
          setLoading(false);
        });
  };

  // section useEffect 

  useEffect(() => {
    attemptLoadMovimientos();
    dispatch(updateLocation({ online: true }));
  }, []);

  useEffect(() => {
    if (print === true) {
      tabValue === "daily"
        ? printTable(document.getElementById("table-print"))
        : printTable(document.getElementById("wallet-table-print"));
    }
    setPrint(false);
  }, [print]);

  useEffect(() => {
    if (search && tabValue === "daily") {
      attemptLoadMovimientos().then(() => {
        setSearch(false);
      });
    } else if (search && tabValue === "wallet") {
        loadWalletMovements(agencieSelected).then(() => {
        setSearch(false);
      });
    }
  }, [search, agencieSelected, tabValue]);

  return isReady ? (
    <Grid container className={styles.container}>
      <Grid item container xs={11} className={styles.header}>
        <Grid item lg={6} md={6} xs={12} className={styles.titleContainer}>
          <AttachMoneyIcon sx={{ fontSize: "1.8rem", color: "primary.main" }} />
          <h4>{t("dailyTransactionsDetail")}</h4>
        </Grid>

        <Grid item xs={12} className={styles.filters}>
          <Button
            variant="contained"
            className={styles.filterButton}
            onClick={() => setOpenFilter(true)}
          >
            <TuneRoundedIcon
              sx={{ color: "secondary.light", fontSize: "1.8rem" }}
            />
            <p style={{ fontSize: "0.9rem" }}>{t("filter")}</p>
          </Button>
          {searching ? (
            <Button
              variant="contained"
              sx={{ ml: 1 }}
              className={styles.filterButton}
              onClick={() => {
                setFilterParams({
                  dateFrom: diaAyer(),
                  dateTo: diaHoy(),
                  concept: "",
                });
                setMovimientos([]);
                setDateFrom(diaAyer());
                setDateTo(diaHoy());
                setSearching(false);
              }}
            >
              <p style={{ fontSize: "0.9rem" }}>{t("cleanFilters")}</p>
            </Button>
          ) : null}
          <Button
            sx={{ ml: 1 }}
            onClick={showHide}
            color="primary"
            className={styles.filterButton}
            variant="contained"
          >
            <p style={{ fontSize: "0.7rem" }}>{t("selectAgency")}</p>
          </Button>
        </Grid>
      </Grid>

      <Grid
        sx={{ marginBottom: "1vw", mt: 2 }}
        justifyContent="center"
        alignItems="center"
        item
        container
        xs={11}
      >
        <Grid
          container
          item
          xs={7}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h4 className={styles.date}>
            {t("dateRange")}:{" "}
            <span className={styles.inputationDate}>
              {filterParams?.dateFrom}{" "}
              {filterParams?.dateFrom.length && filterParams?.dateTo.length
                ? "al"
                : "-"}{" "}
              {filterParams?.dateTo}
            </span>
          </h4>
        </Grid>
        <Grid item container xs={5} sx={{ justifyContent: "flex-end" }}>
          <Button
            size="small"
            variant="contained"
            sx={{ mr: 1, height: "2.5rem" }}
            className={styles.optionsContainer}
            onClick={() => setPrint(true)}
          >
            <PrintIcon
              sx={{ fontSize: "1.5rem", color: textColor }}
              className={styles.iconOptions}
            />
          </Button>

          <Button
            size="small"
            variant="contained"
            className={styles.optionsContainer}
            onClick={() => excelDownload()}
            sx={{ height: "2.5rem" }}
          >
            <DescriptionIcon
              sx={{ fontSize: "1.5rem", color: textColor }}
              className={styles.iconOptions}
            />
          </Button>
        </Grid>
      </Grid>

      <Grid className={styles.selectAgency} item xs={11}>
        <p style={{ fontSize: "1.3rem", fontWeight: "300" }}>
          {agencieSelected?.name
            ? `${t("salePoint")}: (${agencieSelected.number}${
                agencieSelected.subNumber !== null
                  ? " - " + agencieSelected.subNumber
                  : ""
              }) ${agencieSelected.name}`
            : t("agencyNotSelected")}
        </p>
        {showModal && (
          <AgencySelectModal
            open={showModal}
            setOpen={setShowModal}
            onSelect={handleConsulting}
          />
        )}
      </Grid>
      <Grid item xs={12} className={styles.content}>
        <Grid item xs={12} className={styles.tabContainer}>
          <Tabs
            value={tabValue}
            onChange={handleChangeTab}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="online tabs"
            className={styles.tabs}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab
              value="daily"
              label={t("dailyTransactionsDetail")}
              className={`${styles.tabItem} ${
                tabValue === "daily" && styles.selected
              }`}
            />
            <Tab
              value="wallet"
              label={t("depositsWithdrawals")}
              className={`${styles.tabItem} ${
                tabValue === "wallet" && styles.selected
              }`}
            />
          </Tabs>
        </Grid>

        <Grid item xs={12} className={styles.render}>
          {tabValue === "daily" && (
            <>
              {loading ? (
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "300px",
                  }}
                >
                  <CircularProgress size="3rem" />
                </Grid>
              ) : print !== true ? (
                <>
                  <Grid item xs={12} height="300px">
                    <TableContainer className={styles.tableContainer}>
                      <Table
                        stickyHeader
                        className={print ? "print-table" : styles.table}
                      >
                        <TableHead>
                          <TableRow>
                            {[
                              "subagency",
                              "client",
                              "date",
                              "imputation",
                              "descriptionCode",
                              "couponQuantity",
                              "total",
                            ].map((key) => (
                              <TableCell
                                key={key}
                                className={styles.headCell}
                                sx={{
                                  backgroundColor: "primary.main",
                                  color: textColor,
                                }}
                              >
                                {key === "total" ? `${t(key)}($)` : t(key)}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {movimientos?.length ? (
                            movimientos.map((item, i) => (
                              <TableRow
                                key={`${item.subagencia || item.subAgencia}-${item.cliente}-${i}`}
                                sx={
                                  print
                                    ? {
                                        backgroundColor:
                                          item.subAgencia === null
                                            ? "secondary.main"
                                            : "primary.light",
                                      }
                                    : {
                                        "&:hover": {
                                          backgroundColor: "secondary.light",
                                        },
                                      }
                                }
                              >
                                <TableCell>
                                  {item.subagencia || item.subAgencia}
                                </TableCell>
                                <TableCell>{item.cliente}</TableCell>
                                <TableCell>{item.fecha}</TableCell>
                                <TableCell>{item.descripcionJuego}</TableCell>
                                <TableCell>{item.movimiento}</TableCell>
                                <TableCell>{item.cantidadCupones}</TableCell>
                                <TableCell>
                                  <Currency value={item.totalImporte} />
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <TableCell colSpan={7}>{t("noInfo")}</TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} id="table-print">
                  {agencieSelected.agencyLevel ===
                  organization_Configuration.settlementWay ? (
                    <Grid
                      justifyContent="space-between"
                      alignItems="center"
                      container
                      item
                      xs={11}
                      sx={{ mt: 3 }}
                    ></Grid>
                  ) : (
                    <></>
                  )}
                  <TableContainer className={styles.tableContainer}>
                    <Table
                      stickyHeader
                      className={print ? "print-table" : styles.table}
                    >
                      <TableHead>
                        <TableRow>
                          {[
                            "subagency",
                            "client",
                            "date",
                            "imputation",
                            "descriptionCode",
                            "couponQuantity",
                            "total",
                          ].map((key) => (
                            <TableCell
                              key={key}
                              className={styles.headCell}
                              sx={{
                                backgroundColor: "primary.main",
                                color: textColor,
                              }}
                            >
                              {key === "total" ? `${t(key)}($)` : t(key)}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {movimientos?.length ? (
                          movimientos.map((item, i) => (
                            <TableRow
                              key={`${item.subagencia || item.subAgencia}-${item.cliente}-${i}`}
                              sx={
                                print
                                  ? {
                                      backgroundColor:
                                        item.subAgencia === null
                                          ? "secondary.main"
                                          : "primary.light",
                                    }
                                  : {
                                      "&:hover": {
                                        backgroundColor: "secondary.light",
                                      },
                                    }
                              }
                            >
                              <TableCell>
                                {item.subagencia || item.subAgencia}
                              </TableCell>
                              <TableCell>{item.cliente}</TableCell>
                              <TableCell>{item.fecha}</TableCell>
                              <TableCell>{item.descripcionJuego}</TableCell>
                              <TableCell>{item.movimiento}</TableCell>
                              <TableCell>{item.cantidadCupones}</TableCell>
                              <TableCell>
                                <Currency value={item.totalImporte} />
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={7}>{t("noInfo")}</TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              )}
            </>
          )}

          {tabValue === "wallet" && (
            <>
              { loading ? (
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "300px",
                    }}
                  >
                    <CircularProgress size="3rem" />
                  </Grid>
                ) : print !== true ? (
                  <>
                    <Grid container className={styles.wrapper}> {/* $PA */}
                      {/* TABLA */}
                      <Grid item xs={12} className={styles.tableWrapper}>
                        {!walletMovements?.length ? (
                          <div className={styles.loader}>{t("noResults")}</div>
                        ) : (
                          <TableContainer
                            className={styles.tableContainer}
                            id="wallet-table"
                          >
                            <Table stickyHeader className={styles.table}>
                              <TableHead>
                                <TableRow>
                                  <TableCell
                                    className={styles.tableHeadCell}
                                    sx={{
                                      backgroundColor: "primary.main",
                                      color: textColor,
                                    }}
                                  >
                                    {t("salePoint")}
                                  </TableCell>
                                  <TableCell
                                    className={styles.tableHeadCell}
                                    sx={{
                                      backgroundColor: "primary.main",
                                      color: textColor,
                                    }}
                                  >
                                    {t("movements")}
                                  </TableCell>
                                  <TableCell
                                    className={styles.tableHeadCell}
                                    sx={{
                                      backgroundColor: "primary.main",
                                      color: textColor,
                                    }}
                                  >
                                    {`${t("totalMovements")} ($)`}
                                  </TableCell>
                                </TableRow>
                              </TableHead>

                              <TableBody>
                                {walletMovements.map((element, i) => (
                                  <TableRow key={`${element.puntoVenta || "row"}-${i}`}>
                                    <TableCell
                                      size="small"
                                      className={`${styles.tableCell} ${
                                        i % 2 ? styles.rowEven : styles.rowOdd
                                      }`}
                                    >
                                      {element.puntoVenta ?? "-"}
                                    </TableCell>

                                    <TableCell
                                      size="small"
                                      className={`${styles.tableCell} ${
                                        i % 2 ? styles.rowEven : styles.rowOdd
                                      }`}
                                    >
                                      {element.movimiento || "-"}
                                    </TableCell>

                                    <TableCell
                                      size="small"
                                      className={`${styles.tableCell} ${
                                        i % 2 ? styles.rowEven : styles.rowOdd
                                      }`}
                                    >
                                      <Currency value={element.importe} />
                                    </TableCell>
                                  </TableRow>
                                ))}

                                {/* TOTAL */}
                                <TableRow>
                                  <TableCell colSpan={2} align="right">
                                    <strong>{t("total")}</strong>
                                  </TableCell>
                                  <TableCell align="right">
                                    <strong>
                                      <Currency
                                        value={walletMovements.reduce(
                                          (acc, b) => acc + (b.importe || 0),
                                          0,
                                        )}
                                      />
                                    </strong>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} id="wallet-table-print">
                  <TableContainer className={styles.tableContainer}>
                  <Table
                    stickyHeader
                    className={print ? "print-table" : styles.table}
                  >
                    <TableHead>
                      <TableRow>
                        {[
                          "Punto de Venta",
                          "Movimientos",
                          "Total Movimientos ($)",
                        ].map((key) => (
                          <TableCell
                            key={key}
                            className={styles.headCell}
                            sx={{
                              backgroundColor: "primary.main",
                              color: textColor,
                            }}
                          >
                            {key === "total" ? `${t(key)}($)` : t(key)}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {walletMovements?.length ? (
                        walletMovements.map((item, i) => (
                          <TableRow
                            key={`${item.puntoVenta}-${i}`}
                            sx={
                              print
                                ? {
                                    backgroundColor:
                                      item.puntoVenta === null
                                        ? "secondary.main"
                                        : "primary.light",
                                  }
                                : {
                                    "&:hover": {
                                      backgroundColor: "secondary.light",
                                    },
                                  }
                            }
                          >
                            <TableCell>
                              {item.puntoVenta || "-"}
                            </TableCell>
                            <TableCell>{item.movimiento}</TableCell>
                            <TableCell>{item.importe}</TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={7}>{t("noInfo")}</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                  </Grid>
                )
              }
            </>
          )}

        </Grid>
      </Grid>
      <ModalProviders
        open={openFilter}
        setOpen={setOpenFilter}
        setFilters={setFilterParams}
        filters={filterParams}
        setSearching={setSearching}
        setSearch={setSearch}
        tabValue={tabValue}
        dateFrom={dateFrom}
        dateTo={dateTo}
        setDateFrom={setDateFrom}
        setDateTo={setDateTo}
        movimientos={movimientos}
      />
    </Grid>
  ) : (
    <Grid container className={styles.container}>
      <Grid item container xs={11} className={styles.header}>
        <Grid item lg={6} md={6} xs={12} className={styles.titleContainer}>
          <h4>Próximamente.</h4>
        </Grid>
      </Grid>
    </Grid>
  );
};
